import { render, staticRenderFns } from "./import-modal.vue?vue&type=template&id=db2e20e4&"
import script from "./import-modal.vue?vue&type=script&lang=ts&"
export * from "./import-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports